import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var GridItemContainerPremiumSpecial = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement("div", { className: "flex flex--guts grid-item-container " + IdStyles.BuildMenuGridItemWrapper + " " + (className || "") + " ", onClick: onClick },
        React.createElement("div", { className: IdStyles.GridItemContainerPremiumSpecial + " " + (className || "") }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/GridItemContainerPremiumSpecial.tsx
// module id = 2656
// module chunks = 3